import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios, { PublicKey } from "../../API/axios";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";

const ApplyJob = ({ jobId, isAppliedByYou, getAlljobList, instituteAppliedJobsInfo }) => {
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const [loading, setLoading] = useState("");


  const [checkApplied, setCheckApplied] = useState(isAppliedByYou);

  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleShow = () => setShowAppliedModal(true);
  const handleCloseModal = () => setShowAppliedModal(false);

  const [batchId, setBatchId] = useState(null);
  const [ClassId, setClassId] = useState(null);

  const [batchList, setBatchList] = useState([]);
  const [ClassList, setClassList] = useState([]);


  const [selectedType, setSelectedType] = useState("");
  // ..................................Apply Institute Modal...................................
  const [applyInstitute, setApplyInstitute] = useState(false);
  const handleApplyInstitute = () => setApplyInstitute(true);
  const handleCloseApplyInstitute = () => setApplyInstitute(false);
  // .................................Apply Institute Modal...................................

  // ..............................................................................................................
  //                                    ApplyJob Api Institute and Candidate Start
  // ..............................................................................................................

  const handleBatch = (val) => {
    setBatchId(val.value);
  };
  const handleClass = (val) => {
    setClassId(val.value);
  };



  // ..............ApplyJob by Institute
  const [isLoading, setIsLoading] = useState(false);
  const handleApplyJob = async () => {
    setIsLoading(true); // Show a loader while the API request is in progress

    try {
      const response = await axios.post(`/JobAction/ApplyJobAsInstt`, {
        sessionId: sessionId,
        jobId: jobId,
        icbid: batchId,
        icsid: ClassId,
      });

      console.log("API Response:", response);
      toast.success("Job applied successfully!");
      // handleApplyJob();
      setCheckApplied(true);
      setApplyInstitute(false);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error("Failed to apply for the job. Please try again.");
    } finally {
      setIsLoading(false); // Hide loader after request is completed
    }
  };

  // ..............ApplyJob by Cnddt
  const [CheckCandidateApplied, setCheckCandidateApplied] =
    useState(isAppliedByYou);
  const ApplyJob = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`/JobAction/ApplyJobAsCnddt`, {
        sessionId: sessionId,
        jobId: jobId,
      });
      console.log("ApplyJob", response);
      toast.success(response.data.message);
      setCheckCandidateApplied(true);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false); // Stop loading
    }
  };
  // ...............................................................................................................
  //                                    ApplyJob Api Institute and Candidate End
  // ...............................................................................................................
  // ..............................................................................................................
  //                                    UnApplyJob Api Institute and Candidate Start
  // ..............................................................................................................
  // Unapply job by Institute
  const UnApplyJobInstitute = async () => {
    console.log("Unapply inst clicked for Class ID:", ClassId, batchId);
    setLoading(true); // Start loading
    try {
      const response = await axios.post(`/JobAction/UnApplyJobAsInstt`, {
        sessionId: sessionId,
        jobId: jobId,
        icsid: ClassId,
        icbid: batchId,
      });
      console.log("UnApplyJob", response);
      toast.success(response.data.message);
      setShowAppliedModal(false);
      setCheckApplied(false);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Unapply job by candidate
  const UnApplyJobCandidate = async () => {
    console.log("unapply candidate clicked");

    setLoading(true); // Start loading
    try {
      const response = await axios.post(`/JobAction/UnApplyJobAsCnddt`, {
        sessionId: sessionId,
        jobId: jobId,
      });
      console.log("UnApplyJob", response);
      toast.success(response.data.message);
      setCheckCandidateApplied(false); // Mark as unapplied
      setShowAppliedModal(false);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // ...............................................................................................................
  //                                    UnApplyJob Api Institute and Candidate End
  // ...............................................................................................................

  // ...................................................................................................................
  //                                                  Class and Batch Api Start
  // ...................................................................................................................
  // ........................... Class API
  const GetCandidateClass = () => {
    const data = {
      sessionId: sessionId,
      name: "",
      type: "Class",
    };
    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Class data", response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setClassList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // ........................... BATCH API
  const GetCandidateBatch = () => {
    console.log("=========>");

    const data = {
      sessionId: sessionId,
      name: "",
      type: "Batch",
    };
    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Class data=====>", response.data.responseData);
        const res = response.data.responseData;
        console.log("res", res);

        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        console.log("data===>", data);

        setBatchList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
 

  // ...................................................................................................................
  //                                                  Group and Batch Api End
  // ...................................................................................................................

  const [viewApplyList, setViewApplyList] = useState(false);

  const openModal = () => setViewApplyList(true); // Open modal
  const closeModal = () => setViewApplyList(false); // Close modal

  // Extract classIDs and classNames from instituteAppliedJobsVM
  const classIDs = instituteAppliedJobsInfo?.classIDs || [];
  const batchIDs = instituteAppliedJobsInfo?.batchIDs || [];

  return (
    <>
      {/*............................ Applied & Unapply Institute Button Start ............................*/}

      {userType === "Institution" ? (
        <>
          <Button className="mainBtn apply-job" 
          onClick={()=> {handleApplyInstitute();
             GetCandidateClass();
             GetCandidateBatch();
          }}>
            Apply Now
          </Button>
          {instituteAppliedJobsInfo === null ? '' : (
            <VisibilitySharpIcon
              style={{ cursor: "pointer" }}
              className="ms-2 joblist-eye-icon locationIcon"
              onClick={openModal}
            />
          )}
        </>

      ) : (
        <>
          {CheckCandidateApplied === true ? (
            <div className="appliedbtn mb-1">
              <Button
                className="mainBtn  appliedBtn apply-job"
                style={{ width: "100px" }}
                onClick={() => {
                  handleShow();
                }}
              >
                <span className="default-text">Applied</span>
                <span className="hover-text">Withdraw</span>
              </Button>
            </div>
          ) : (
            <Button className="mainBtn apply-job" onClick={ApplyJob}>
              Apply Now
            </Button>
          )}
        </>
      )}
      {/*............................ Applied & Unapply Candidate Button End ..............................*/}

      {/*................................ Apply Institute Modal Start ...............................*/}
      <Modal show={applyInstitute} onHide={handleCloseApplyInstitute}>
        <Modal.Header closeButton>
          <Modal.Title>Apply for the Job</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseApplyInstitute} />
        </Modal.Header>
        <Modal.Body className="settings">
          {/* <p>Here you can applying to the job.</p> */}
          <Row>
            <Col md={12}>
              <Form.Group controlId="Name_Title">
                <Form.Label className="class-type">
                  Type
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
              </Form.Group>
              <div className="post-form-group">
                <Form.Group controlId="batchDropdown">
                  <Form.Control
                    as="select"
                    className="Dark-Input-from-group"
                    defaultValue="Select Type"
                    onChange={(e) => setSelectedType(e.target.value)}
                    placeholder="Select Type"
                  >
                    <option disabled>Select Type</option>
                    <option value="Class">Class</option>
                    <option value="Batch">Batch</option>
                  </Form.Control>
                </Form.Group>
              </div>
            </Col>
          </Row>
          <div className="post-form-row">
            {selectedType === "Batch" && (
              <Col md={12}>
                <div className="post-form-group">
                  <label htmlFor="type">Batch</label>

                  <ReactSelect
                    options={batchList}
                    onChange={handleBatch}
                    placeholder="Select Batch"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />

                </div>
              </Col>
            )}
            {selectedType === "Class" && (
              <Col md={12}>
                <div className="post-form-group">
                  <label htmlFor="type">Class</label>
                  <ReactSelect
                    options={ClassList}
                    onChange={handleClass}
                    placeholder="Select Class"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                </div>
              </Col>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseApplyInstitute}>
            Close
          </Button>
          <Button
            className="apply-job"
            variant="primary"
            onClick={handleApplyJob}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/*.................................. Apply Institute Modal End ..................................*/}

      {/*.................................... UnApply Job Modal Start ................................*/}

      <Modal show={showAppliedModal} onHide={handleCloseModal} centered>
        <Modal.Header>
          <Modal.Title> UnApply Job</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to UnApply Job</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={
              userType === "Institution"
                ? UnApplyJobInstitute
                : UnApplyJobCandidate
            }
            className="btn btn-danger me-2"
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
      {/*.................................... UnApply Job Modal End ................................*/}


      {/*................................ Apply Institute Modal list start...............................*/}
      <Modal show={viewApplyList} onHide={closeModal}>
        <Modal.Header >
          <Modal.Title>View Applied Classes</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={closeModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          {classIDs.length === 0 ?
            ""
            : (
              <>
                <div className="classlist">
                  <h4>Classes</h4>
                  <ul>
                    {classIDs.map((id, index) => (
                      <li key={id} className="d-flex justify-content-between align-item-center">
                        <div className="name">
                          {instituteAppliedJobsInfo?.classNames[index]} 
                        </div>
                        <div className="appliedbtn mb-2">
                          <Button
                            className="InsApplybtn mainBtn  appliedBtn  apply-job  mt-0"
                            style={{
                              width: "100px"
                            }}
                            onClick={() => {
                              handleShow();
                              setClassId(instituteAppliedJobsInfo.classIDs[0].toString())
                              // getAlljobList()
                            }}
                          >
                            <span className="default-text">Applied</span>
                            <span className="hover-text">Withdraw</span>
                          </Button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
          {batchIDs.length === 0 ?
            ""
            : (
              <>
                <div className="batchlist">
                  <h4>Batches</h4>
                  <ul>
                    {batchIDs.map((id, index) => (
                      <li key={id} className="d-flex justify-content-between align-item-center">
                        <div className="name">
                          {instituteAppliedJobsInfo?.batchNames[index]}
                        </div>
                        <div className="appliedbtn mb-1">
                          <Button
                            className="InsApplybtn mainBtn  appliedBtn apply-job  mt-0"
                            style={{ width: "100px" }}
                            onClick={() => {
                              handleShow();
                              setBatchId(instituteAppliedJobsInfo.batchIDs[0].toString())

                            }}
                          >
                            <span className="default-text">Applied</span>
                            <span className="hover-text">Withdraw</span>
                          </Button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
        </Modal.Body>


      </Modal>
      {/*.................................. Apply Institute list End ..................................*/}

    </>
  );
};

export default ApplyJob;
